import { useState, useMemo, useEffect, useRef } from "react"
import { useRequest } from "ahooks";
import { Card, message } from "antd";
import { Table, DEFAULT_PAGE_DATA } from "../../../components/table";
import { generateTableColumns, DEFAULT_QUERY_DATA, generateQueryFormConfig } from "./config";
import { AmountServer } from "../../../server";
import { EditForm } from "../../../components/editForm";
import { Operation } from "./operation";

const server = AmountServer.UserAddress
const server2 = AmountServer.Recharge

export const UserAddress = () => {
    const operationRef: any = useRef();
    const [queryData, setQueryData] = useState<any>({ ...DEFAULT_QUERY_DATA });
    const [loading, setLoading] = useState<boolean>(false);
    const [tableData, setTableData] = useState<any[]>([]);
    const [pageData, setPageData] = useState<any>({ ...DEFAULT_PAGE_DATA });
    const [networkOptions, setNetworkOptions] = useState<any>([])

    //获取表格数据
    const { run, refresh } = useRequest(server.list, {
        defaultParams: [{ ...pageData, ...queryData }],
        onBefore: () => setLoading(true),
        onFinally: () => setLoading(false),
        onError: () => {
            setTableData([]);
            setPageData({ ...pageData, Total: 0 });
        },
        onSuccess: (res: any) => {
            const { Total, List, Page, PageSize } = res;
            setTableData(List);
            setPageData({ Page, PageSize, Total });
        }
    });
    const getNetworkTypes = async () => {
        // 调用后端API
        const response = await server2.networkType({});
        if (response) {
            const convertedArray = Object.entries(response).map(([value, label]) => ({
                id: Number(value), // 如果需要 value 是数字类型
                name: label
            }));
            setNetworkOptions(convertedArray)
        }
    }
    useEffect(()=> {
        getNetworkTypes()
    }, [])
    // 删除 
    const { run: deleteData } = useRequest(server.delete, {
        manual: true,
        onBefore: () => setLoading(true),
        onFinally: () => setLoading(false),
        onSuccess: () => {
            refresh();
            message.success("删除成功");
        }
    });
    const getQueryFormConfig = useMemo(() => {
        return generateQueryFormConfig({ networkOptions });
    }, [networkOptions]);

    const getTableColumns = useMemo(() => {
        return generateTableColumns({ operationRef, deleteData, loading, setLoading, refresh });
    }, [operationRef, deleteData, loading]);

    return (
        <div>
            <Card>
                <EditForm
                    componentId="card-record-query-form"
                    loading={loading}
                    formAttrsProps={{
                        layout: 'inline',
                    }}
                    formData={queryData}
                    onDataChange={setQueryData}
                    formConfig={getQueryFormConfig}
                    onQuery={() => {
                        run({ ...DEFAULT_PAGE_DATA, ...queryData });
                    }}
                    onReset={() => {
                        setQueryData({ ...DEFAULT_QUERY_DATA });
                        run({ ...DEFAULT_QUERY_DATA, ...DEFAULT_PAGE_DATA });
                    }}
                />
            </Card>
            <Card className="mt20">
                <Table
                    loading={loading}
                    dataSource={tableData}
                    columns={getTableColumns}
                    rowKey="Id"
                    scroll={{
                        x: 'max-content'
                    }}
                    page={pageData}
                    onPageChange={(Page: number, PageSize: number) => {
                        const currentPage = { ...pageData, Page, PageSize };
                        run({ ...currentPage, ...queryData });
                    }}
                />
            </Card >
            <Operation ref={operationRef} onSuccess={refresh} />
        </div>
    );
}